import { Breadcrumb, Button, Table } from 'antd';
import { Layout } from '../../components/layout';
import { UserDrawer } from './components';
import type { UsersProps, UserType } from './Users.types.ts';

import './Users.styles.css';
import { BREADCRUMBS, USERS_COLUMNS } from './Users.constants.tsx';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '../admin/components';
import { FiPlus } from 'react-icons/fi';
import { useEffect } from 'react';

export default function Users({
  users,
  isLoading,
  openUserDrawer,
  onOpenUserDrawer,
  onCloseUserDrawer,
  onSubmitUser,
  userId,
}: UsersProps) {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `Administration ${t('pages.admin.module.users')}`;
  }, [t]);
  return (
    <Layout>
      {isLoading ? (
        <Skeleton />
      ) : (
        <div className="admin-page">
          <Breadcrumb className="breadcrumb" items={BREADCRUMBS} />

          <div className="admin-page-bar">
            <h1 className="admin-page-bar--title">{t('pages.admin.module.users')}</h1>
            <div className="admin-page-bar--actions">
              <Button
                icon={<FiPlus />}
                iconPosition="start"
                size="large"
                type="primary"
                onClick={(event) => onOpenUserDrawer(event, null)}
              >
                {t('common.add-new')}
              </Button>
            </div>
          </div>
          <Table<UserType>
            rowKey="id"
            columns={USERS_COLUMNS}
            dataSource={users}
            onRow={(record) => {
              return {
                onClick: (event: React.MouseEvent<HTMLButtonElement>) =>
                  onOpenUserDrawer(event, record?.id),
              };
            }}
          />
          {openUserDrawer && (
            <UserDrawer
              open={openUserDrawer}
              onClose={onCloseUserDrawer}
              onSubmit={onSubmitUser}
              userId={userId}
            />
          )}
        </div>
      )}
    </Layout>
  );
}
